<button mat-stroked-button class="gray-2" (click)="close()" [disabled]="disabled">CANCELAR</button>
<button mat-raised-button class="primary-1" (click)="submit()" [disabled]="disabled">OK</button>
